"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PronunciationDictionariesCreateFromFileRequestWorkspaceAccess = void 0;
exports.PronunciationDictionariesCreateFromFileRequestWorkspaceAccess = {
    Admin: "admin",
    Editor: "editor",
    Viewer: "viewer",
};
